<template>
    <NuxtLayout>
        <div class="prose">
            <template v-if="error?.statusCode === 404">
                <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
                    <div class="text-center">
                        <p class="text-indigo-600 text-base font-semibold">404</p>
                        <h1 class="text-gray-900 mt-4 text-balance text-5xl font-semibold tracking-tight sm:text-7xl">
                            Page not found
                        </h1>
                        <p class="text-gray-500 mt-6 text-pretty text-lg font-medium sm:text-xl/8">
                            Sorry, we couldn’t find the page you’re looking for.
                        </p>
                        <div class="mt-10 flex items-center justify-center gap-x-6">
                            <a
                                href="/"
                                class="bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                >Go back home</a
                            >
                        </div>
                    </div>
                </main>
            </template>
            <template v-else>
                <h1>Error</h1>
                <p>
                    <strong>{{ error?.message }}</strong>
                </p>
                <p>It looks like something broke.</p>
                <p>Sorry about that.</p>
                <a
                    href="/"
                    class="bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    >Go back home</a
                >
            </template>
        </div>
    </NuxtLayout>
</template>

<script setup lang="ts">
    const error = useError();
</script>
